exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success {\n  background-color: green;\n  padding: 1%;\n  color: white;\n  margin: 1%;\n  border-radius: 7%; }\n\n.failed {\n  background-color: red;\n  padding: 1%;\n  color: white;\n  margin: 1%;\n  border-radius: 7%; }\n\n.no-audit-logs {\n  text-align: center;\n  font-size: 24px;\n  color: #000000;\n  font-weight: bold; }\n\n.updated-by {\n  font-weight: 500;\n  width: 650px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-list-audit/order-list-audit.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/order-list/order-list-audit/order-list-audit.component.scss
// module chunks = main